import serviceClient from '../../service-client/service-client';
import actionTypes from '../constants/action-types';

const exportStatus = {
  IN_PROGRESS: 'in_progress',
  COMPLETE: 'complete',
};

const siteExporter = () => (next) => (action) => {
  if (action.type !== actionTypes.EXPORT_SITE) {
    next(action);
    return;
  }

  const {
    options,
    siteId,
    onSuccess = Function.prototype,
    onFail = Function.prototype,
  } = action.payload;

  const apiClient = serviceClient.get();

  apiClient
    .exportSite(siteId, options)
    .then((response) => {
      const {
        data: { id },
      } = response;

      function pollExportJob() {
        apiClient
          .getAsyncJob(id)
          .then((res) => {
            const {
              data: { status, results },
            } = res;

            switch (status) {
              case exportStatus.IN_PROGRESS:
                setTimeout(pollExportJob, 1000);
                break;
              case exportStatus.COMPLETE:
                onSuccess(results);
                next(action);
                break;
            }
          })
          .catch((error) => {
            onFail(error);
            next(action);
          });
      }

      pollExportJob();
    })
    .catch((error) => {
      onFail(error);
      next(action);
    });
};

export default siteExporter;
